import { FocusEvent, useState } from 'react';
import Select, { SelectProps } from 'components/molecules/Select';
import { Keywords } from 'utils/gloo-types';
import { removeDuplicateSpaces, removeNonChars, convertToSelectOptions } from 'utils/index';
import { SelectOption } from 'utils/frontendTypes';
import { isString } from 'utils/common';

function SelectKeywords({
  dataDurableId,
  startingKeywords,
  onChange,
  onCreate,
  ...rest
}: Partial<SelectProps> & {
  startingKeywords?: (Partial<Keywords> | string)[];
  onCreate: (s: string) => any;
  onChange: (s: string[]) => any;
  dataDurableId: string;
}) {
  const [selectedKeyWords, setSelectedKeyWords] = useState(() => {
    return convertToSelectOptions((startingKeywords || []).map((k: Keywords | string) => (isString(k) ? k : k.text)));
  });

  const handleCreateKeyword = (inputValue: string) => {
    const lowerOnlyChars = removeDuplicateSpaces(removeNonChars(inputValue.toLowerCase()));
    if (!lowerOnlyChars) {
      return;
    }
    setSelectedKeyWords([...selectedKeyWords, { label: lowerOnlyChars, value: lowerOnlyChars }]);
    onCreate(lowerOnlyChars);
  };

  const handleChangeKeywords = (option: SelectOption[]) => {
    if (!option) {
      onChange([]);
      setSelectedKeyWords([]);
      return;
    }

    const newKeywords = (option || []).map((o) => o.value);
    onChange(newKeywords);
    setSelectedKeyWords(option);
  };

  const handleBlur = (e: FocusEvent<HTMLInputElement>) => {
    const inputVal = e?.target?.value || '';

    if (inputVal) {
      const lowerOnlyChars = removeDuplicateSpaces(removeNonChars(inputVal.toLowerCase()));
      if (lowerOnlyChars) {
        setSelectedKeyWords([...selectedKeyWords, { label: lowerOnlyChars, value: lowerOnlyChars }]);
        onCreate(lowerOnlyChars);
      }
    }
  };

  return (
    <Select
      dataDurableId={dataDurableId}
      noOptionsMessage={() => 'Type a keyword, then press ENTER'}
      onBlur={handleBlur}
      isMulti
      isCreateable
      placeholder="Type a keyword, then press ENTER"
      onCreateOption={handleCreateKeyword}
      onChange={handleChangeKeywords}
      value={selectedKeyWords}
      components={{ DropdownIndicator: null }}
      {...rest}
    />
  );
}

export default SelectKeywords;
